import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteEquipment, getEquipment } from "../../../actions/equipments/equipments";
import EquipmentListComponent from "../../../components/Definition/Equipment/EquipmentListComponent";

export default function EquipmentScreen() {
    const [equipment, setEquipment] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getEquipment({page:params.toString()});
                setLoading(false);
                setEquipment(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <EquipmentListComponent lists={equipment} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید تجهیز حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteEquipment(id);
                    if (response.status === "success") {
                        toast.success("تجهیز حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف تجهیز!");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
